import React from 'react';
import NumberFormat from 'react-number-format';

interface CustomProps {
  onChange: (event: {
    target: { name: string; value: number | string };
  }) => void;
  name: string;
}

const FormatPhoneInput = React.forwardRef<
  NumberFormat<string | number>,
  CustomProps
>(function NumberFormatCustom(props, ref) {
  const { onChange, ...other } = props;

  return (
    <NumberFormat
      getInputRef={ref}
      onValueChange={(values) => {
        const numericValue = values.value ? Number(values.value) : '';
        onChange({
          target: {
            name: props.name,
            value: numericValue
          }
        });
      }}
      format="(###) ###-####"
      mask="_"
      allowNegative={false}
      {...other}
    />
  );
});

export default FormatPhoneInput;
